/** 레거시 `settlementSheetConfig.js` 포팅 — 정산·수수료 공용 */
const HEADER_AREA_SCAN_ROWS = 8;

export const cleanHeaderText = (value: unknown): string => {
  if (value == null) return '';
  return String(value)
    .normalize('NFC')
    .replace(/\r?\n/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
};

export const normalizeHeaderToken = (value: unknown): string =>
  cleanHeaderText(value)
    .replace(/\s+/g, '')
    .replace(/[()[\]{}:★※,_/.-]/g, '')
    .toLowerCase();

export const buildSheetHeaderProfile = (
  sheetName: string,
  rows: unknown[][] = [],
) => {
  const headerAreaRows = rows
    .slice(0, HEADER_AREA_SCAN_ROWS)
    .map((row, rowIndex) => ({
      rowIndex,
      cells: row.map(cleanHeaderText).filter(Boolean),
    }))
    .filter((item) => item.cells.length > 0);

  const candidateRows = rows
    .slice(0, 20)
    .map((row, rowIndex) => ({
      rowIndex,
      headers: row.map(cleanHeaderText).filter(Boolean),
    }))
    .filter((item) => item.headers.length >= 3);

  const bestCandidate =
    candidateRows.sort(
      (left, right) => right.headers.length - left.headers.length,
    )[0] ?? null;

  return {
    sheetName,
    headerRowIndex: bestCandidate ? bestCandidate.rowIndex : -1,
    headers: bestCandidate ? bestCandidate.headers : [],
    headerAreaRows,
  };
};

export const extractWorkbookHeaderProfilesFromRows = (
  workbook: { SheetNames: string[] },
  sheetRowsMap: Record<string, unknown[][]>,
) =>
  workbook.SheetNames.map((sheetName) =>
    buildSheetHeaderProfile(sheetName, sheetRowsMap[sheetName] ?? []),
  );

export { HEADER_AREA_SCAN_ROWS };
